<template>
  <el-main class="main-con el-main">
    <router-view></router-view>
  </el-main>
</template>

<script>
    export default {
        name: "Contract"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/Contract.vue